import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class AmenityService {

    static getAmenity(item) {

        let api = `${API_BASE_URL}${API_PATHS.getAmenity}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addAmenity(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addAmenity}`;
        return axiosInstance
            .post(api, data)

    }

    static editAmenity(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editAmenity}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteAmenity(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteAmenity}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default AmenityService;
